import { render, staticRenderFns } from "./CustomerSel.vue?vue&type=template&id=aec3ae70&"
import script from "./CustomerSel.vue?vue&type=script&lang=js&"
export * from "./CustomerSel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports